import { flowApi } from '.';

export const lookupsService = flowApi.injectEndpoints({
  overrideExisting: true,

  endpoints: (builder) => ({
    getTableLookups: builder.query<
      {
        comparisons: string[];
      },
      {
        columnId: string;
      }
    >({
      query: ({ columnId }) => ({
        url: 'Lookups/TableViews/ConditionComparisons',
        params: {
          columnId,
        },
      }),
    }),
    getAgendasLookups: builder.query<
      {
        comparisons: string[];
      },
      {
        formItemId: string;
      }
    >({
      query: ({ formItemId }) => ({
        url: 'Lookups/AgendaViews/ConditionComparisons',
        params: {
          formItemId,
        },
      }),
    }),
  }),
});
export const { useGetAgendasLookupsQuery, useGetTableLookupsQuery, useLazyGetAgendasLookupsQuery, useLazyGetTableLookupsQuery } = lookupsService;
